import {get} from 'lodash'
import {ready} from './addiesaas'
import $ from 'jquery'
import ls from './storage'

const store = 'auth' // user, token
const storage = 'system/authentication.token' // user, token

export const isLoggedIn = () => {
  const token = get(ls(store) || {}, storage, null)
  return !!token
}
export const update = (dom, forcedLoginStatus) => {
  const loggedIn = forcedLoginStatus !== undefined ? forcedLoginStatus : isLoggedIn()
  dom.find('.re-login-status > a').hide()
  if (loggedIn) {
    dom.find('.re-login-status .re-status-profile-link').show().attr('style', 'display: block !important')
  } else {
    dom.find('.re-login-status .re-status-sign-in-link').show().attr('style', 'display: block !important')
  }
}

export const auth = {
  isLoggedIn,
  update: update,
  init(urls) {
    const loginLink = urls.login
    const profileLink = urls.profile
    const dom = $(`
      <div class="addiesaas-component">
        <div class="rocket-effect-container re-mini-component re-login-status">
          <a href="${loginLink}" class="re-status-sign-in-link addiesaas-switch-guest">
            <!--<span>Sign In</span>-->
          </a>
          <a href="${profileLink}" class="re-status-profile-link addiesaas-switch-authenticated">
            <!--<span>My Account</span>-->
          </a>
        </div>
      </div>
    `)

    ready(() => {
      const EventBus = window.VueEventBus
      if (EventBus) {
        EventBus.$on('user.logout', function () {
          update(dom, false)
        });
        EventBus.$on('user.data.failed', function () {
          update(dom, false)
        });
        EventBus.$on('user.token', function () {
          update(dom, true)
        });
        EventBus.$on('user.data.loaded', function () {
          update(dom, true)
        });
      }
    })

    return dom
  }
}
export default auth
